import styled from '@emotion/styled';
import { Button, PlanBadge, Stack, Text } from '@hotjar/hotsauce';
import { useAddImageButton } from './useAddImageButton';

export interface AddImageButtonProps {
  imageURL: string | undefined;
  onChangeImage: (props: {
    imageBase64: string | undefined;
    imageObjectURL: string | undefined;
  }) => void;
}

const ButtonContainer = styled(Stack)`
  align-items: center;
`;

const HiddenInput = styled.input`
  display: none !important;
`;

export const AddImageButton = ({ imageURL, onChangeImage }: AddImageButtonProps): JSX.Element => {
  const { label, icon, info, fileInputRef, onClickButton, onChangeFile, hasPlanBadge } =
    useAddImageButton({ imageURL, onChangeImage });

  return (
    <Stack direction="column" spacing="x1">
      <ButtonContainer>
        <HiddenInput
          data-testid="question-image-input"
          type="file"
          ref={fileInputRef}
          onChange={onChangeFile}
          accept=".png, .gif, .jpg, .jpeg, .webp"
        />
        <Button onClick={onClickButton} title={label} icon={icon} kind="secondary" size="s">
          {label}
        </Button>
        {hasPlanBadge && <PlanBadge size="s" kind={hasPlanBadge} onClick={onClickButton} />}
      </ButtonContainer>
      <Text textType="caption" textColor="text_light">
        {info}
      </Text>
    </Stack>
  );
};
